export function RecipeBookMark() {
  return (
    <svg aria-hidden="true" className="mark" viewBox="0 0 48 48">
      <rect height="34" rx="4" width="34" x="7" y="7" />
      <path d="M14 17h20M14 24h20M14 31h11" />
    </svg>
  )
}
